import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';

// Import your reducers
import rootReducer from './reducers';

// Create the Redux store
const store = configureStore({
  reducer: rootReducer,
  // Add any additional configuration options here
});

export default store;
